import { render, staticRenderFns } from "./CourseSeries.vue?vue&type=template&id=454543b9&"
import script from "./CourseSeries.vue?vue&type=script&lang=js&"
export * from "./CourseSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports